import { AdaptiveSheet } from '../common';
import { AddPropertyForm } from './AddPropertyForm';

interface AddPropertySheetProps {
  visible: boolean;
  onClose: () => void;
  initialAddress?: string;
}

/**
 * Profile, the structure page, and phone/tablet host for AddPropertyForm: an
 * AdaptiveSheet around the same form the desktop map route docks directly
 * instead (PropertyDockPanel.web.tsx) — panel-system.md Phase 2, same
 * DefensePlanAssignForm/Sheet split as Phase 1. Mounted globally
 * (app/_layout.tsx) and gated on `activeSheet === 'addProperty'`, same as
 * before this split, except on the desktop shell's map route, where
 * app/_layout.tsx suppresses this host in favor of the dock.
 */
export function AddPropertySheet({ visible, onClose, initialAddress }: AddPropertySheetProps) {
  return (
    <AdaptiveSheet
      isOpen={visible}
      onRequestClose={onClose}
      onDismiss={onClose}
      keyboardBehavior="interactive"
      keyboardBlurBehavior="restore"
      androidKeyboardInputMode="adjustResize"
      dialogWidth={560}>
      <AdaptiveSheet.ScrollView keyboardShouldPersistTaps="handled">
        <AddPropertyForm visible={visible} onClose={onClose} initialAddress={initialAddress} />
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
